export const COACH_RESOURCES = {
  // SKYHAWKS SPORTS WITH FULL SCHEDULES (6/7/2025)
  'baseball_camp': [{
    item: 'Baseball Camp Schedule',
    url: 'https://drive.google.com/file/d/1cvBmkzSIBC9p1vI2gqVlrLqTRHwpUG3A/view?usp=drive_link'
  }],
  'basketball_camp': [{
    item: 'Basketball Camp Schedule',
    url: 'https://drive.google.com/file/d/1BYcLkQewkPgSbBKofdJ76dHNSiH0wMHW/view?usp=drive_link'
  }],
  'basketball_class': [{
    item: 'Basketball Class Schedule',
    url: 'https://drive.google.com/file/d/1U0v0CAkjmBCgWqIrk8CR4xaAPzSGah7c/view?usp=drive_link'
  }],
  'flag-football_camp': [{
    item: 'Flag Football Camp Schedule',
    url: 'https://drive.google.com/file/d/1JijtUHpOmBOMwvWV3A4LhyqisCJw2_hK/view?usp=drive_link'
  }],
  'flag-football_class': [{
    item: 'Flag Football Class Schedule',
    url: 'https://drive.google.com/file/d/1Qc0SK6rWfISYoF3xWKJVNbjKNtATF3ED/view?usp=drive_link'
  }],
  'golf_camp': [
    {
      item: 'Golf Camp Schedule',
      url: 'https://drive.google.com/file/d/1-VBSroVp0M-KdF4-mbma03wtoFbPJByF/view?usp=drive_link'
    }
  ],
  'golf_class': [
    {
      item: 'Golf Class Schedule',
      url: 'https://drive.google.com/file/d/13oaIbTRJWPNgwlLjGaK2TEAJGb0xOSQF/view?usp=drive_link'
    }
  ],
  'lacrosse_camp': [{
    item: 'Lacrosse Camp Schedule Planner',
    url: 'https://drive.google.com/file/d/166ViOH61Y7MiYq_fBFkWxSHy1Ie4TORj/view?usp=drive_link'
  }],
  'lacrosse_class': [{
    item: 'Lacrosse Class Schedule Planner',
    url: 'https://drive.google.com/file/d/1gvijBHrEJx3LMXqx3FXQMnGfnqIRTPPq/view?usp=drive_link'
  }],
  'mini-hawk_camp': [
    {
      item: 'Baseball+Football+Soccer Camp Schedule',
      url: 'https://drive.google.com/file/d/1a_lPX2G4rfI-T4QTGgZ2bdKmkUIY3A_N/view?usp=drive_link'
    },
    {
      item: 'Basketball+Baseball+Soccer Camp Schedule',
      url: 'https://drive.google.com/file/d/1pWhX7SF9bBfi0Lr8iQSIbtcAGaVCgeVm/view?usp=drive_link'
    }
  ],
  'multi-sport_camp': [
    {
      item: 'Baseball+Football+Soccer Half Day Camp Schedule',
      url: 'https://drive.google.com/file/d/1ZEUjjvCEHR1vmej7LTGcBtCrx0tdkFqk/view?usp=drive_link'
    },
    {
      item: 'Basketball+Baseball+Soccer Half Day Camp Schedule',
      url: 'https://drive.google.com/file/d/1vuxWgXMAecYk2j5_1E_xB0fslRFeyXMz/view?usp=drive_link'
    },
    {
      item: 'Baseball+Football+Soccer Full Day Camp Schedule',
      url: 'https://drive.google.com/file/d/19vsRiuUW6LvBidFS7DbcUTk8OjVnx4Xx/view?usp=drive_link'
    },
    {
      item: 'Basketball+Baseball+Soccer Full Day Camp Schedule',
      url: 'https://drive.google.com/file/d/19MMnGk4-NQd4fx90l8NJXi5AfGRSqnSA/view?usp=drive_link'
    }
  ],
  'multi-sport_class': [
    {
      item: 'Multi-Sport Class Instructions',
      url: 'https://drive.google.com/file/d/1S9_YdQdmTcBSB4_KPFR52bOZldFob5BR/view?usp=drive_link'
    }
  ],
  'mini-multi-sport-stem_camp': [
    {
      item: 'Multi-Sport STEM (K-2) Camp Worksheets',
      url: 'https://drive.google.com/file/d/1h44FdRAKEOg7Ha3UY5rcXYylwOc8XCJC/view?usp=drive_link'
    },
    {
      item: 'Multi-Sport STEM (K-2) Camp Schedule',
      url: 'https://drive.google.com/file/d/1PbNZeR-Hd21_IkPRBYklOT5SGot4k-w6/view?usp=drive_link'
    },
    {
      item: 'Baseball+Football+Soccer Camp Schedule (Use as reference)',
      url: 'https://drive.google.com/file/d/1IN6wgufhVTKvLOKFVa-0oKylwA-RMUes/view?usp=drive_link'
    },
  ],
  'pickleball_class': [{
    item: 'Pickleball Class Schedule',
    url: 'https://drive.google.com/file/d/1qwO1xP1CZKKwwcibwQrL6JyP2vLaIypz/view?usp=drive_link'
  }],
  'pickleball_camp': [{
    item: 'Pickleball Camp Schedule',
    url: 'https://drive.google.com/file/d/1fLlXXF_-v6u1aGpihDvogn7LN9XE6299/view?usp=drive_link'
  }],
  'soccer_camp': [{
    item: 'Soccer Camp Schedule',
    url: 'https://drive.google.com/file/d/1QBG2N1I9fQjaSjmK0GJ9wF3Qhk8ZXJhJ/view?usp=drive_link'
  }],
  'soccer_class': [{
    item: 'Soccer Class Schedule',
    url: 'https://drive.google.com/file/d/1WDH0GMaQp4TekVJ32CIkW1huFM0RIVyW/view?usp=drive_link'
  }],
  'tennis_camp': [{
    item: 'Tennis Camp Schedule',
    url: 'https://drive.google.com/file/d/19CjB7L-wpGdL0XOxtvdNm6WzldQxAVeH/view?usp=drive_link'
  }],
  'tennis_class': [{
    item: 'Tennis Class Schedule',
    url: 'https://drive.google.com/file/d/1ScO7I3S_CE9u6Hr1c8JS-b89vENltB8k/view?usp=drive_link'
  }],
  'track-field_camp': [{
    item: 'Track & Field Camp Schedule',
    url: 'https://drive.google.com/file/d/1l7intW_LBNi45wOlu2R1LhEZ4JVvAHvl/view?usp=drive_link'
  }],
  'track-field_class': [{
    item: 'Track & Field Class Schedule',
    url: 'https://drive.google.com/file/d/16IYsBrvrmrcQds1GGSmIrHP-CmZxZ9A3/view?usp=drive_link'
  }],
  'volleyball_camp': [{
    item: 'Volleyball Camp Schedule',
    url: 'https://drive.google.com/file/d/1NxvEZ-4T4jAbmUUto25kuYvTf__uJqm5/view?usp=sharing'
  }],
  'volleyball_class': [{
    item: 'Volleyball Class Schedule',
    url: 'https://drive.google.com/file/d/16ILj0NUY16e-qMmTaA0xLyhxJ24z6EOa/view?usp=drive_link'
  }],

  // TOTS PROGRAMS
  'baseball-tots_class': [
    {
      item: 'BaseballTots 8-Week Planner',
      url: 'https://drive.google.com/file/d/1qhTAts-ZHl7lpzeovix1InGgPhUtbYBL/view?usp=drive_link'
    },
    {
      item: 'BaseballTots Games Manual',
      url: 'https://drive.google.com/file/d/10f8Lf0ISCGYFwBLX3Quwk5Rez8qKpxtE/view?usp=drive_link'
    }
  ],
  'basketball-tots_class': [
    {
      item: 'HoopsterTots 8-Week Planner',
      url: 'https://drive.google.com/file/d/1qTcr2j2OWxW19HGhoFk-1M2kZYbnc27R/view?usp=drive_link'
    },
    {
      item: 'HoopsterTots Games Manual',
      url: 'https://drive.google.com/file/d/1T9v0HXmhNukosTEHsai8qJqlX4vuuLcI/view?usp=drive_link'
    }
  ],
  'flag-football-tots_class': [
    {
      item: '1stDownTots 8-Week Planner',
      url: 'https://drive.google.com/file/d/1qTcr2j2OWxW19HGhoFk-1M2kZYbnc27R/view?usp=drive_link'
    },
    {
      item: '1stDownTots Games Manual',
      url: 'https://drive.google.com/file/d/1T9v0HXmhNukosTEHsai8qJqlX4vuuLcI/view?usp=drive_link'
    }
  ],
  'multi-sport-tots_class': [
    {
      item: 'Multi-SportTots Instructions',
      url: 'https://drive.google.com/file/d/1PasRdQBFYDuZVygFM0iZ2-ehFxkW96TX/view?usp=drive_link'
    },
    {
      item: 'HoopsterTots 8-Week Planner',
      url: 'https://drive.google.com/file/d/1qTcr2j2OWxW19HGhoFk-1M2kZYbnc27R/view?usp=drive_link'
    },
    {
      item: 'HoopsterTots Games Manual',
      url: 'https://drive.google.com/file/d/1T9v0HXmhNukosTEHsai8qJqlX4vuuLcI/view?usp=drive_link'
    },
    {
      item: 'SoccerTots 8-Week Planner',
      url: 'https://drive.google.com/file/d/1LMPqZ2S7NyMQkmQ6wohEoBFtVW3bAeQA/view?usp=drive_link'
    },
    {
      item: 'SoccerTots Games Manual',
      url: 'https://drive.google.com/file/d/1zG6fJA2_7FiKVLTCqeCUv2UcCIt1Y8l-/view?usp=drive_link'
    },
    {
      item: 'VolleyKats 8-Week Planner',
      url: 'https://drive.google.com/file/d/1NQYgIaE7GPJG0c4Mg-BroXWTLiTyuCM_/view?usp=drive_link'
    },
    {
      item: 'VolleyKats Games Manual',
      url: 'https://drive.google.com/file/d/1zAT0RHip49usawjT75HBTiChXYm1t-Xl/view?usp=drive_link'
    }
  ],
  'soccer-tots_class': [
    {
      item: 'SoccerTots 8-Week Planner',
      url: 'https://drive.google.com/file/d/1LMPqZ2S7NyMQkmQ6wohEoBFtVW3bAeQA/view?usp=drive_link'
    },
    {
      item: 'SoccerTots Games Manual',
      url: 'https://drive.google.com/file/d/1zG6fJA2_7FiKVLTCqeCUv2UcCIt1Y8l-/view?usp=drive_link'
    },
  ],
  'volleyball-tots_class': [
    {
      item: 'VolleyKats 8-Week Planner',
      url: 'https://drive.google.com/file/d/1NQYgIaE7GPJG0c4Mg-BroXWTLiTyuCM_/view?usp=drive_link'
    },
    {
      item: 'VolleyKats Games Manual',
      url: 'https://drive.google.com/file/d/1zAT0RHip49usawjT75HBTiChXYm1t-Xl/view?usp=drive_link'
    }
  ],
};

export default COACH_RESOURCES;